// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"9e2c81dd","977":"2a7c6c1f"}[chunkId] + ".chunk.js";
};